import _default from './Responsive';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/addons/Responsive/index.js
// module id = 615
// module chunks = 0